import React, { useEffect, useState, useRef } from 'react'
import { collection, addDoc, doc, getDoc, orderBy, onSnapshot, setDoc, getDocs, deleteDoc, updateDoc, arrayUnion, serverTimestamp, query } from "firebase/firestore";
import { db } from "../firebase";
import { useParams } from 'react-router-dom';
import { Alert, Button, message, Tabs, Input, Tag, Avatar } from 'antd';
import 'antd/dist/antd.css';
import { Link, useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { data } from 'autoprefixer';
import 'antd/dist/antd.css';
import MyProjects from './MyProjects';
import { async } from '@firebase/util';
import UserOutlined from '@ant-design/icons';

const ProjectDetail = () => {
  const { id } = useParams();

  const { user } = UserAuth();
  const userUID = user.uid;

  const [project, setProject] = useState(null);
  const [isAttendee, setIsAttendee] = useState(null);
  const [listUsers, setListUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const [updateChat, setUpdateChat] = useState(false);

  const [open, setOpen] = useState(false);
  const [childrenDrawer, setChildrenDrawer] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const showChildrenDrawer = () => {
    setChildrenDrawer(true);
  };

  const onChildrenDrawerClose = () => {
    setChildrenDrawer(false);
  };

  useEffect(() => {
    const getProject = async () => {
      try {
        const docRef = doc(db, "projects", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setProject(docSnap.data());
          if (docSnap.data().members?.includes(user.email)) {
            setIsAttendee(true);
          } else {
            setIsAttendee(false);
          }
        } else {
          // if doc.data() is undefined 
          message.error("No such document!");
        }

      } catch (error) {
        setError(error);
      }
      setLoading(false);

    };
    getProject();
  }, []);


  const navigate = useNavigate();


  const handleDelete = async () => {
    try {
      await deleteDoc(doc(db, "projects", id));
      message.success("Project deleted");
    } catch (error) {
      message.error("Error deleting project");
    }
  };

  // add user to project
  const handleAddUser = async () => {
    const docRef = doc(db, "users", userUID, "appliedProjects", id);
    await setDoc(docRef, {
      id: id,
    });
    try {
      if (project?.rejectedUsers?.includes(user.userUID)) {
        message.error("You have been rejected from this project");
        return
      } else if (project?.appliedUsers?.includes(user.userUID)) {
        message.error("You have already applied to this project");
        return
      }
      else {
        const docRef = doc(db, "projects", id, "appliedUsers", userUID);
        await setDoc(docRef, {
          email: user.email,
          name: user.displayName,
          requesterID: userUID,
          status: "pending",
        });
        await updateDoc(doc(db, "projects", id), {
          members: arrayUnion(user.email),
          appliedUsers: arrayUnion(userUID),
        });
        await updateDoc(doc(db, "users", userUID, "appliedProjects", id), {
          id: id,
        });
        message.success("Your request has been sent");
        setIsAttendee(true);
        navigate("/projects");
      }
    } catch (error) {
      message.error("Error applying to project");
    }
    reloadPage();
  };

  // remove user from project
  const handleRemoveUser = async () => {
    const docRef = doc(db, "users", userUID, "appliedProjects", id);
    await setDoc(docRef, {
      id: id,
    });
    try {
      if (project?.rejectedUsers.includes(user.userUID)) {
        message.error("You have been rejected from this project");
        return
      }
      else {
        const docRef = doc(db, "projects", id, "appliedUsers", userUID);
        await setDoc(docRef, {
          email: user.email,
          name: user.displayName,
          requesterID: userUID,
          status: "cancelled",
        });
        await updateDoc(doc(db, "projects", id), {
          appliedUsers: project?.appliedUsers.filter((user) => user !== userUID),
          acceptedUsers: project?.acceptedUsers.filter((user) => user !== userUID),
          rejectedUsers: project?.rejectedUsers.filter((user) => user !== userUID),
        });
        await updateDoc(doc(db, "users", userUID, "appliedProjects", id), {

        });
        message.success("Your request has been sent");
        setIsAttendee(false);
        navigate("/projects");
      }
    } catch (error) {
      message.error("Error applying to project");
    }
    reloadPage();
  };

  const reloadPage = () => {
    window.location.reload();
  }


  useEffect(() => {
    const listMembers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "projects", id, "appliedUsers"));
        const data = querySnapshot.docs.map((doc) => doc.data());
        setListUsers(data);
      } catch (error) {
        message.error("Error getting members");
      }
    };
    listMembers();
  }, []);


  useEffect(() => {
    const listMessages = async () => {
      try {
        const q = query(collection(db, "projects", id, "Messages"), orderBy("createdAt", "asc"));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const data = querySnapshot.docs.map(
            (doc) => ({ ...doc.data(), id: doc.id })
          );
          setMessages(data);
        });
        return unsubscribe;
      } catch (error) {
        message.error("Error getting messages");
      }
    };
    listMessages();
  }, []);


  const handleSendMessage = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "projects", id, "Messages"), {
        message: message,
        sender: user.displayName,
        createdAt: serverTimestamp(),
        senderID: userUID,
      });
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      setMessage("");
      setUpdateChat(!updateChat);
    } catch (error) {
      message.error("Error sending message");
    }
  };

  const messagesEndRef = useRef();

  const ChatMessage = ({ message, sender, uuid, createdAt, key }) => {
    const [isOwner, setIsOwner] = useState(false);
    useEffect(() => {
      if (uuid === userUID) {
        setIsOwner(true);
      }
    }, [userUID, uuid]);
    return (
      <div className={isOwner ? "message__owner" : "message__other"}>
        <div className="flex flex-col bg-slate-500 rounded-lg p-2">
          <div className="flex justify-between">
            <p className="text-white font-bold">{sender}</p>
            <p className="text-white text-xs">{createdAt?.toDate().toLocaleString()}</p>
          </div>
          <p className="text-white">{message}</p>
        </div>
      </div>
    );
  };


  const handleRejectUser = async (requesterID) => {
    const docRef = doc(db, "projects", id, "appliedUsers", requesterID);
    await updateDoc(docRef, {
      status: "rejected",
    });
    await updateDoc(doc(db, "projects", id), {
      rejectedUsers: arrayUnion(requesterID),
      acceptedUsers: project?.acceptedUsers.filter((user) => user !== requesterID),
      appliedUsers: project.appliedUsers.filter((item) => item !== requesterID),
    });
    message.success("User rejected");
  }

  const handleAcceptUser = async (requesterID) => {
    const docRef = doc(db, "projects", id, "appliedUsers", requesterID);
    try {
      updateDoc(docRef, {
        status: "accepted",
      });
      await updateDoc(doc(db, "projects", id), {
        acceptedUsers: arrayUnion(requesterID),
        rejectedUsers: project.rejectedUsers.filter((item) => item !== requesterID),
        appliedUsers: project.appliedUsers.filter((item) => item !== requesterID),
      });
      message.success("User accepted");
    }
    catch (error) {
      message.error("Error accepting user");
    }
  }

  return (
    <div>
      <>

        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8
        
        ">
          <Button type="primary" ghost>
            <Link to="/projects">Back to Projects</Link>
          </Button>

          {
            userUID === project?.OwnerUid ? (

              <Button
                type="danger"
                style={{ float: 'right', }}

                onClick={() => handleDelete(project?.project_ID)}
              >Delete Project</Button>

            ) : (
              <>

                {project?.cancelledUsers?.includes(userUID) ? (
                  <>
                    <Tag color="red" style={{ float: 'right', }}>Cancelled</Tag>
                    <Button type="primary" style={{ float: 'right', }} onClick={() => handleAddUser()}>Re-apply</Button>
                  </>
                ) : (
                  null
                )}

                {project?.appliedUsers?.includes(userUID) ? (
                  <>
                    <Tag color="orange" style={{ float: 'right', }}>Pending</Tag>
                    <Button type="danger" style={{ float: 'right', }} onClick={handleRemoveUser}>Remove yourself</Button>
                  </>
                ) : (
                  <>
                    {project?.acceptedUsers?.includes(userUID) || project?.cancelledUsers?.includes(userUID) || project?.rejectedUsers?.includes(userUID) ? (
                      <><Tag color="green" style={{ float: 'right', }}>Accepted</Tag>
                        <Button type="danger" style={{ float: 'right', }} onClick={handleRemoveUser}>Remove yourself</Button>
                      </>
                    ) : (
                      <Button type="primary" style={{ float: 'right', }} onClick={() => handleAddUser()}>Apply</Button>
                    )}
                  </>
                )}
                {project?.rejectedUsers?.includes(userUID) ? (
                  <>
                    <Tag color="red" style={{ float: 'right', }}>Rejected</Tag>
                    <Button type="primary" style={{ float: 'right', }} onClick={() => handleAddUser()}>Re-apply</Button>
                  </>
                ) : (
                  null
                )}

              </>
            )
          }
        </div>

        <div className="overflow-hidden bg-white shadow sm:rounded-lg">
          <div className=" border-gray-200">
            <dl>
              <Tabs defaultActiveKey="1" className=''>
                <Tabs.TabPane tab="Project Details" key="item-1">
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">
                      Project Name
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {project?.title}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Desired Role</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {project?.desiredRole}
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">About the Project</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {project?.description}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Salary expectation</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      RM {project?.salary ? project?.salary : "Contact for details"}
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Project Phases</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {project?.phases}
                    </dd>
                  </div>


                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Project Duration</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      from  {project?.startDate} to {project?.endDate}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Project Requirements</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {project?.requirements}
                    </dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Project Skills</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {project?.skills || 'Not specified'}
                    </dd>
                  </div>

                  {/* Table for project members */}
                  {
                    userUID === project?.OwnerUid ? (
                      <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">Applied Users</dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                          <ul role="list" className="divide-y divide-gray-200 rounded-md border border-gray-200">

                            {

                              project?.members ? listUsers.map((user) => (
                                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" key={user?.uid}>
                                  <div className='flex flex-col'>
                                    <Link className='text-blue-500  hover:text-blue-800' to={`/profile/${user?.requesterID}`}>{user?.name}</Link>
                                    {user?.status === 'pending' ? (
                                      <Tag color="orange">Pending</Tag>
                                    ) : (
                                      null)}

                                    {user?.status === 'accepted' ? (
                                      <Tag color="green">Accepted</Tag>
                                    ) : (
                                      null)}

                                    {user?.status === 'rejected' ? (
                                      <Tag color="red">Rejected</Tag>
                                    ) : (
                                      null)}

                                    {user?.status === 'completed' ? (
                                      <Tag color="blue">Completed</Tag>
                                    ) : (
                                      null)}

                                    {user?.status === 'cancelled' ? (
                                      <Tag color="red">Cancelled</Tag>
                                    ) : (
                                      null)}


                                  </div>
                                  <div className="mt-0 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                    <Button type="danger" style={{ float: 'right', }}
                                      onClick={() => handleRejectUser(user?.requesterID)}
                                    >
                                      Reject
                                    </Button>

                                    <Button type="primary" style={{ float: 'right', marginRight: '10px' }}
                                      onClick={() => handleAcceptUser(user?.requesterID)}
                                    >
                                      Accept
                                    </Button>

                                  </div>
                                </div>
                              ))

                                : <>
                                  <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                    <div className="w-0 flex-1 flex items-center">
                                      <span className="ml-2 flex-1 w-0 truncate">
                                        No users applied yet
                                      </span>
                                    </div>
                                  </li>
                                </>

                            }
                          </ul>
                        </dd>
                      </div>
                    ) : (
                      <>

                      </>
                    )

                  }
                </Tabs.TabPane>
                <Tabs.TabPane tab="Chat" key="2" disabled={userUID === project?.OwnerUid || project?.acceptedUsers.includes(userUID) ? false : true}>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3sm:gap-4 sm:px-6">
                    <dd className="mt-1 text-sm text-gray-900 w-full sm:col-span-2 sm:mt-0">
                      <div className="flex flex-col bg-slate-200 rounded-md p-4">
                        <div className="flex flex-col h-96 w-full overflow-y-scroll">
                          <div className="flex flex-col p-4  gap-3">
                            {messages.map((message) => (
                              <div className="" key={message.id}>
                                {message.senderID === userUID ? (
                                  <div className="flex flex-row-reverse rounded-md">
                                    <div className="flex flex-col-reverse sm:flex-row-reverse gap-2 max-w-xl  bg-blue-400 text-white rounded-md p-2">
                                      {message.message}

                                    </div>
                                    <p className="text-xs text-blue-400">{message.createdAt?.toDate().toString()}</p>

                                  </div>
                                ) : (
                                  <div className="flex flex-col sm:flex-row gap-2 max-w-5xl  text-white rounded-md ">
                                    <Avatar size={30} style={{ backgroundColor: '#f56a00' }} >{message.sender.charAt(0)} </Avatar>
                                    <div className="flex flex-row gap-2 max-w-xl bg-gray-400 rounded-md p-2">
                                      {message.message}
                                    </div>
                                    <p className="text-xs visible  text-blue-400">{message.createdAt?.toDate().toString()}</p>
                                  </div>
                                )}
                              </div>
                            ))}


                          </div>
                        </div>
                        <div className="flex flex-row mt-2 gap-3">
                          <input className="flex-1  rounded-md p-2" type="text" value={message} onChange={(e) => setMessage(e.target.value)} />
                          <button className="bg-blue-500 text-white p-2 flex-row rounded-md" onClick={handleSendMessage}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </dd>
                  </div>


                </Tabs.TabPane>
              </Tabs>

            </dl>
          </div>
        </div>
      </>
    </div>
  )
}

export default ProjectDetail

